<template>
	<div class="flsm">
		<div class="banimg banimg1">
			<div class="txt">
				<div class="w1200">
					{{ $t('gsjj') }}
					<p>not just a customer, but partners</p>
				</div>
			</div>
			<img src="../../assets/img/bg_Introduction.png" alt="">
		</div>
		<div class="mbxs">
			<div class="w1100">
				<router-link class="on" to='/about'>{{ $t('gsjj') }}</router-link>
				<router-link to='/gszl'>{{ $t('gszl') }}</router-link>
				<!-- <router-link to='/news'>{{ $t('xwzx') }}</router-link> -->
			</div>
		</div>
		<div class="jjnr">
			<div class="w1100">
				<div class="nr1">
					<div class="nr">
						<div class="t">
							{{ $t('gsjj') }}
						</div>
						<p>{{ $t('gsjj1') }}
						</p>
					</div>
					<img :src="require('../../assets/img/' + $t('tpdz') + 'about1.jpg')" alt="">
				</div>
			</div>
			<div class="img w1100">
				<img :src="require('../../assets/img/' + $t('tpdz') + 'lsjc_2.png')">
			</div>
		</div>

		<div class="jjnr1">
			<div class="w1100">
				<div class="indexT" style="text-align: left;">
					{{ $t('zzyry') }}
				</div>
				<ul class="zzry">

					<li class="cols">
						<div class="li">
							<img src="../../assets/img/gxjsqy.png" alt="">
							<p>{{ $t('gxqy') }}</p>
						</div>
					</li>
					<li class="cols">
						<div class="li">
							<img src="../../assets/img/zjtxzxqy.png" alt="">
							<p>{{ $t('zjtxzxqy') }}</p>
						</div>
					</li>
					<li class="cols">
						<div class="li">
							<img src="../../assets/img/cxxzxqy.png" alt="">
							<p>{{ $t('cxxzxqy') }}</p>
						</div>
					</li>
					<li class="cols">
						<div class="li" style="text-align: center; width: 60%;">
							<img src="../../assets/img/ndyq.png" alt="" >
							<p v-html="$t('ndyq')"></p>
						</div>
					</li>
				</ul>
				<br />
				<p>{{ $t('zzyryms') }}</p>

			</div>
		</div>


		<div class="jjnr1">
			<div class="w1100">
				<div class="indexT" style="text-align: left;">
					{{ $t('gsjj2') }}
				</div>
				<x-row :gutter="40">
					<x-col class="col" lg='8' md='12' xs="24">
						<div>
							<p>• {{ $t('gsjj3') }}</p>
							{{ $t('gsjj4') }}
						</div>
					</x-col>
					<!-- <x-col class="col" lg='8' md='12' xs="24">
						<div>
							<p>•{{$t('gsjj5')}}</p>
							{{$t('gsjj6')}}
						</div>
					</x-col> -->
					<x-col class="col" lg='8' md='12' xs="24">
						<div>
							<p>• {{ $t('gsjj7') }}</p>
							{{ $t('gsjj8') }}<br /><br />
							{{ $t('gsjj8_1') }}
						</div>
					</x-col>
					<x-col class="col" lg='8' md='12' xs="24">
						<div>
							<p>• {{ $t('gsjj9') }} </p>
							{{ $t('gsjj10') }}
						</div>
					</x-col>
					<x-col class="col" lg='16' md='24' xs="24">
						<div>
							<p>{{ $t('gsjj11') }}</p>
							{{ $t('gsjj12') }}
						</div>
					</x-col>
				</x-row>
			</div>
		</div>
		<div class="w1100">
			<div style="text-align: left;" class="indexT">
				Total Solution Service
			</div>
			<div style="text-align: center; padding: 0 0 80px;">
				<img src="../../assets/img/about_1.png" alt="">
			</div>
		</div>

	</div>
</template>

<script>
export default {
	data() {
		return {
			locale: '',
		}
	},

	created() {

	},
}

</script>

<style lang="scss" scoped>
.zzry {
	justify-content: center;
	display: flex;
	li {
		width: 25%;
		display: inline-block;
		margin-left: 3%;
	}
	img{
		height: 155px;
	}
	p{
		text-align: center;
		color: #000;
		margin-top:10px;
	}
}
</style>
